import { ICounterOfferApiModel } from '../types/CounterOffer.api';
import { ICounterOfferEntity } from '../types/CounterOffer';

export const toCounterOfferEntity = (api: ICounterOfferApiModel): ICounterOfferEntity => ({
  id: api.id,
  status: api.status,
  rate: api.rate,
  originalRate: api.originalRate,
  begin: api.begin,
  end: api.end,
  originalBegin: api.originalBegin,
  originalEnd: api.originalEnd,
  breakTime: api.breakTime,
  originalBreakTime: api.originalBreakTime,
  expiration: api.expiration,
  knowByTime: api.knowByTime,
  hasWorkedWithOffice: api.hasWorkedWithOffice,
  hasWorkedWithDSO: api.hasWorkedWithDSO,
  payment: {
    hygienistPay: api.payment.hygienistPay,
    tempmeeFee: api.payment.tempmeeFee,
    tempmeeFeeRatio: api.payment.tempmeeFeeRatio,
    peoFee: api.payment.peoFee,
    peoFeeRatio: api.payment.peoFeeRatio,
    convenienceFee: api.payment.convenienceFee,
    convenienceFeeRatio: api.payment.convenienceFeeRatio,
    totalAmount: api.payment.totalAmount,
  },
});
